// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_kuN","cls2":"PaperClaiming-cls2_BDa PaperClaiming-cls1_kuN"};